import { IWindowType } from '../../../generated/graphql.tsx';
import type { SelectOption } from '../../technical/inputs/Select/Select.props.ts';
import { formatEnum } from '../../formatter.utils.ts';

export const BACKEND_MIN_WINDOW = 3;
export const isWindowValid = (windowType: IWindowType, window: string | number | null): boolean => {
  if (windowType === IWindowType.Expanding) {
    return true;
  }

  if (window === null || window === undefined) {
    return false;
  }

  const value = typeof window === 'string' ? Number.parseFloat(window) : window;
  if (!Number.isSafeInteger(value)) {
    return false;
  }

  return value >= BACKEND_MIN_WINDOW;
};

export const windowTypeOptions: SelectOption<IWindowType>[] = Object.entries(IWindowType).map(([key, value]) => ({
  value: value as IWindowType,
  key: key,
  label: formatEnum(value),
}));

export const isWarmUpEnabled = (windowType: IWindowType): boolean => {
  return windowType === IWindowType.Expanding;
};
